module.exports = __webpack_public_path__ + "img/组 2750.1d2bcf45.png";